import rifleShootingWebApp from "../config/rifleShootingWebApp.json";

/**
 * Posted to directly in both dev and production: the Apps Script web app answers
 * text/plain POSTs with permissive CORS, so no dev proxy (and no dev-server restart
 * after changing this URL) is needed.
 */
export const rifleShootingRegistrationWebAppUrl = (rifleShootingWebApp.execUrl || "").trim();

export const rifleShootingMeta = {
  id: "rifle-shooting-2026",
  name: "10.9 Rifle Shooting",
  shortName: "10.9 Rifle Shooting",
  tagline: "Focus, Precision, Composure",
  /** Event day — 1 November 2026. */
  date: "2026-11-01",
  venue: "TBD",
  ageNote: "15 yrs and above",
  /** Age cut-off date the DOB rule is measured against (event day). */
  ageAsOnDate: "2026-11-01",
  ageAsOnLabel: "1 November 2026",
  minAgeYears: 15,
  sponsors: [
    "Asha Singh Mohta Charitable Trust",
    "Smt. Jyoti Sri Ashok Kumar Lakhotia",
  ],
  flyerUrl: "/pages/rifle-shooting/rifle-shooting-flyer.jpeg",
  /** Shown in the drawer's payment block; leave empty to hide the amount line. */
  feeLabel: "Members \u20B9700 \u00B7 Non-members \u20B9800",
  /** `value` is sent as `membership` and must match MEMBERSHIP_OPTIONS in scripts/rifleShootingRegistration.gs. */
  feeOptions: [
    { value: "Member", label: "SMYM Member", amount: "\u20B9700" },
    { value: "Non-member", label: "Non-member", amount: "\u20B9800" },
  ],
  time: "8:30 AM onwards",
  registrationOpen: true,
  registrationWebAppUrl: rifleShootingRegistrationWebAppUrl,
  /** Optional shared secret — must match SUBMIT_SECRET in scripts/rifleShootingRegistration.gs. */
  registrationSubmitSecret: "",
  helplineWhatsApp: { digits10: "8610447053", display: "86104 47053" },
  /** Shared with every registrant on success — venue and all further updates go here. */
  whatsappGroupUrl: "https://chat.whatsapp.com/DjDHz33c2L50f7NZXFA6J3?s=cl&p=a&ilr=4&iam=1",
};

export const RIFLE_SHOOTING_REGISTRATION_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/1Y_XQFhaH8L0Sp7UWFQPKlSgdPDjkMbqjewXlYWzeAHU/edit";
